import PropTypes from 'prop-types';
import { isMobileOrTabletBrowser } from "../../utils/Utils";
const DixuDeviceTarget = _ref => {
  let {
    mobile,
    desktop,
    children
  } = _ref;
  if (typeof window === 'undefined') {
    return null;
  }
  const isMobileOrTablet = isMobileOrTabletBrowser();
  if (mobile && isMobileOrTablet) {
    return children || null;
  }
  if (desktop && !isMobileOrTablet) {
    return children || null;
  }
  return null;
};
DixuDeviceTarget.propTypes = {
  mobile: PropTypes.bool,
  desktop: PropTypes.bool
};
DixuDeviceTarget.defaultProps = {
  mobile: undefined,
  desktop: undefined
};
export default DixuDeviceTarget;